import React from 'react';
import Layout from '../components/Layout/Layout';
import teachingStaffImg from '../images/teachingstaff-image.jpg';
import teachingStaffPdf from '../images/Staff Profile 2026.pdf';

const TeachingStaffPage = () => {
  return (
    <Layout>
      <div id="teaching-staff" className="page-container" style={{ maxWidth: '1200px', fontSize: '0.90rem', margin: '40px auto', padding: '0 20px', minHeight: '300px' }}>
        <h2 style={{ color: 'var(--primary-blue)', borderBottom: '2px solid var(--light-blue)', paddingBottom: '10px', marginBottom: '20px' }}>
          Teaching Staff
        </h2>
        <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
          <p style={{ color: '#555', marginBottom: '15px' }}>Meet our dedicated and highly qualified teaching faculty.</p>
          
          {/* Full Width PDF document */}
          <div style={{ height: '900px', width: '100%', marginTop: '20px' }}>
            <iframe 
              src={teachingStaffPdf} 
              width="100%" 
              height="100%" 
              title="Staff Profile PDF" 
              style={{ border: '1px solid #ccc', borderRadius: '8px', boxShadow: '0 4px 10px rgba(0,0,0,0.05)' }} 
            />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default TeachingStaffPage;
